import * as Yup from "yup";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { Upload, UploadOnAddEvent } from '@progress/kendo-react-upload';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useEffect, useState } from "react";
import { useGetMainGroups } from "../../apiclient/product/useGetMainGroupApi";
import { useGetSubGroups } from "../../apiclient/product/useGetSubGroupApi";
import { useGetUoms } from "../../apiclient/product/useGetUOMApi";
import { SelectField } from "../../core/select-field.component";
import { useGetProductTax } from "../../apiclient/master/useGetProductTaxApi";
import { FormikPage } from "../../core/formik-page-forms";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import ImageUpload from "../../core/image-upload";
import AgentModel from "../../models/party/agent-model";
import axios from "axios";
import { useGetCategories } from "../../apiclient/master/useGetCategoryApi";
import { useGetAgent, useGetGenders } from "../../apiclient/party/useGetAgentApi";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import DropingPointModel from "../../models/party/dropingpoint-model";
import { Field } from 'formik';

interface AgentEditProps {
    data: AgentModel;
    isViewMode?: boolean;
    onClose?: (status: SubmitStatus, data: any) => any;
}

const AgentEntry: React.FC<AgentEditProps> = ({ ...props }) => {
    let { data, onClose, isViewMode } = props;
    const title = data?.agentId > 0 ? "Edit Agent" : "Add Agent";
    const [agent, setAgent] = useState(data);
    // const { setFieldValue, values } = useFormikContext<AgentModel>();

    useEffect(() => {
        setAgent(data);
        console.log("Agent:", data);

        if (data && data.agentId === 0) {
            const fetchAgentCode = async () => {
                try {
                    const response = await getDataWithToken<any>(
                        `${getEndPoint(API_END_POINT.PARTY)}/api/Agent/GetAgentCode`
                    );
                    console.log("Agentcode:", response.data.result[0]);
                    setAgent((prev: any) => ({
                        ...prev,
                        agentCode: response.data.result[0]
                    }));
                    // setAgentCode(response.data.result); 

                } catch (error) {
                    console.error("Failed to fetch agent code", error);

                }
            };

            fetchAgentCode();
        }
    }, [data]);

    let initialValue: AgentModel = {
        agentId: agent?.agentId || 0,
        categoryId: agent?.categoryId || 0,
        agentCode: agent?.agentCode || '',
        firstName: agent?.firstName || '',
        lastName: agent?.lastName || '',
        genderId: agent?.genderId,
        nomineeName: agent?.nomineeName || '',
        nomineeRelation: agent?.nomineeRelation || '',
        aadharNumber: agent?.aadharNumber || '',
        aadharDocumentPath: agent?.aadharDocumentPath || '',
        panNumber: agent?.panNumber || '',
        rationcardNumber: agent?.rationcardNumber || '',
        communicationAddress: agent?.communicationAddress || '',
        email: agent?.email || '',
        address: agent?.address ? agent.address : '',
        mobile: agent?.mobile ? agent.mobile : '',
        alternateMobile: agent?.alternateMobile ? agent.alternateMobile : '',
        pincode: agent?.pincode ? agent.pincode : '',
        imagePath: agent?.imagePath ? agent.imagePath : '',
        phone: agent?.phone ? agent.phone : '',
        gstNumber: agent?.gstNumber ? agent.gstNumber : '',
        bank: agent?.bank || '',
        branch: agent?.branch || '',
        ifscCode: agent?.ifscCode || '',
        accountHolderName: agent?.accountHolderName || '',
        accountNumber: agent?.accountNumber || '',
        isActive: data?.agentId > 0 ? data.isActive : true,

    };
    console.log(initialValue)
    const validationSchema = Yup.object().shape({
        // agentCode: Yup.string().required("Agent code is required"),
        firstName: Yup.string().required("First name is required"),

    });

    const [image, setImage] = useState<File | null>(null);
    const [files, setFiles] = useState<any[]>([]);
    const onAdd = (event: UploadOnAddEvent) => {
        // Get the raw file object from the affected files
        const file = event.affectedFiles[0].getRawFile();
        setImage(file); // Set the file for preview or further processing
        setFiles(event.newState); // Update the list of files
    };
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [existingCode, setExistingCode] = useState<string[]>([]);
    const { data: fetchedagent } = useGetAgent();

    const { data: fetchedCategory } = useGetCategories();
    const { data: fetchedGender } = useGetGenders();
    const [categoryData, setCategoryData] = useState<{ value: string; label: string }[]>([]);
    const [genderData, setGenderData] = useState<{ value: string; label: string }[]>([]);

    useEffect(() => {
        if (fetchedCategory) {
            const mappedCategory = fetchedCategory.map((category: any) => ({
                value: category.categoryId,
                label: category.name,
            }));
            setCategoryData(mappedCategory);
        }
        if (fetchedGender) {
            const mappedGender = fetchedGender.map((gender: any) => ({
                value: gender.genderId,
                label: gender.name,
            }));
            setGenderData(mappedGender);
        }
    }, [fetchedCategory, fetchedGender]);

    // const fetchBankDetails = async (ifscCode: string) => {
    //     if (!ifscCode) return;

    //     try {
    //         const url = `https://ifsc.razorpay.com/${ifscCode}`;

    //         const response = await axios.get(url);

    //         if (response.data && response.data.BANK && response.data.BRANCH) {
    //             setAgent((prev: any) => ({
    //                 ...prev,
    //                 bank: response.data.BANK || prev.bank,
    //                 branch: response.data.BRANCH || prev.branch,
    //             }));
    //         } else {
    //             console.warn("No valid bank data received");
    //             // Only clear if those values were fetched previously (optional logic)
    //             setAgent((prev: any) => ({
    //                 ...prev,
    //                 bank: prev.bank, // preserve existing value
    //                 branch: prev.branch, // preserve existing value
    //             }));
    //         }
    //     } catch (error) {
    //         console.error("Error fetching bank details:", error);
    //         // Preserve existing manually-entered values
    //         setAgent((prev: any) => ({
    //             ...prev,
    //             bank: prev.bank,
    //             branch: prev.branch,
    //         }));
    //     }
    // };

    // const handleIFSCBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    //     const ifscCode = event.target.value;
    //     fetchBankDetails(ifscCode);
    // };



    return (
        <FormikModelDialog
            //key={agent?.agentId || "new"}
            width="80%" // Make the modal full width
            title={title}
            initialData={initialValue}
            validationSchema={validationSchema}
            show={!!data}
            onClose={onClose}
            endpoint={API_END_POINT.PARTY}
            postRoute="Agent/SaveAgent"
            showAddAnother={true}
            isUpDateEntityDetails={agent?.agentId > 0}
            isViewOnly={isViewMode}

        >
            <div className="bg-white-head tabwhitespace" style={{ width: "100%" }}>
                <TabStrip
                    selected={selectedTab}
                    onSelect={(e) => {
                        setSelectedTab(e.selected);
                    }}
                    className="mx-2 mt-3 mb-3 bg-light"
                    style={{ minHeight: "35vh" }}
                >
                    <TabStripTab contentClassName="structureTab" title="Agent Detail">
                        <div className="group-container m-2">
                            <div className="row">
                                <div className="col-md-3">
                                    <SelectField
                                        label="Category*"
                                        name="categoryId"
                                        options={categoryData}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField maxLength={5}
                                        label="Code *"
                                        name="agentCode"
                                        disabled={true} />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={50}
                                        label="First Name"
                                        name="firstName"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={50}
                                        label="Address"
                                        name="address"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={6}
                                        label="Pincode"
                                        name="pincode"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <SelectField
                                        label="Gender"
                                        name="genderId"
                                        options={genderData}
                                    />
                                </div>


                                <div className="col-md-3">
                                    <InputField
                                        maxLength={10}
                                        label="Alternate Mobile"
                                        name="alternateMobile"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={25}
                                        label="Email"
                                        name="email"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={10}
                                        label="Phone"
                                        name="phone"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label>Aadhar Document</label>
                                    <Upload
                                        defaultFiles={[]}
                                        withCredentials={false}
                                        files={files}
                                        onAdd={onAdd}
                                    />
                                    {image && <img src={URL.createObjectURL(image)} alt="Aadhar Document" style={{ height: 95, width: 95 }} />}
                                </div>

                                {/* Image Upload */}
                                <div className="col-md-6 d-flex align-items-center">
                                    {/* Active Checkbox */}
                            <CheckboxField
                                label="Is Active?"
                                name="isActive"
                                checkstyle={CheckBoxStyle.Normal}
                            />
                        </div>
                            </div>
                        </div>
                    </TabStripTab>
                    <TabStripTab contentClassName="structureTab" title="Agent Profile">
                        <div className="m-2">
                            <div className="row">
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={20}
                                        label="Nominee Name"
                                        name="nomineeName"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={20}
                                        label="Nominee Relation"
                                        name="nomineeRelation"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={10}
                                        label="Pan Number"
                                        name="panNumber"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={12}
                                        label="Ration Card Number"
                                        name="rationcardNumber"
                                    />
                                </div>
                            </div>
                        </div>
                    </TabStripTab>
                    <TabStripTab contentClassName="structureTab" title="Agent Bank Details">
                        <div className="m-2">
                            <div className="row">
                                {/* <div className="col-md-3">
                                    <label className="agent-label">IFSC Code</label>
                                    { <input
                                        // label="IFSC Code"
                                        name="ifscCode"
                                        value={agent?.ifscCode || ""}
                                         onChange={(e) => setAgent({ ...agent, ifscCode: e.target.value })}
                                        // onBlur={handleIFSCBlur}
                                         className="input-box"
                                    />
                                    }

                                </div> */}
                                <div className="col-md-3">
                                    <label className="agent-label">IFSC Code</label>
                                    <Field name="ifscCode">
                                        {({ field, form }: any) => (
                                            <input
                                                {...field}
                                                className="input-box"
                                                onBlur={async () => {
                                                    const ifscCode = form.values.ifscCode;
                                                    if (ifscCode) {
                                                        try {
                                                            const url = `https://ifsc.razorpay.com/${ifscCode}`;
                                                            const response = await axios.get(url);
                                                            if (response.data) {
                                                                form.setFieldValue('bank', response.data.BANK || '');
                                                                form.setFieldValue('branch', response.data.BRANCH || '');
                                                            }
                                                        } catch (error) {
                                                            console.error('Error fetching bank details:', error);
                                                        }
                                                    }
                                                }}
                                            />
                                        )}
                                    </Field>
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={50}
                                        label="Bank"
                                        name="bank"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={50}
                                        label="Branch"
                                        name="branch"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <InputField
                                        maxLength={50}
                                        label="Account Holder Name"
                                        name="accountHolderName"
                                    />
                                </div>
                            </div>
                        </div>
                    </TabStripTab>
                </TabStrip>
            </div>
        </FormikModelDialog>
    );
};

export default AgentEntry;